import "./style.css";
import { initMap } from "./src/map";
import { initUrlControls } from "./src/url";
import { initSearch } from "./src/search";
import { initDraw } from "./src/draw";
import { initPopup } from "./src/popup";
import { initPage } from "./src/page";
import { resetMap } from "./src/utils";
import { initHelp } from "./src/help";

const map = initMap();

initSearch(map);
initDraw(map);
initPopup(map);
initUrlControls();
initHelp();
initPage(map);

document.getElementById("reset-btn").addEventListener("click", () => {
  resetMap(map);
});
